import { DwAction, DwActionHandler, DwActionItemRequirement, DwActionResult, 
         DwActionState, DwActionType, DwButtonType, DwGridActionKeys, DwGridActionResult, DwGridMultiEditConfig, 
         DwGridMultiEditConfigComponent, DwMdFormActionState, DwMdPdfResult, DwMetaDataGridActionState, 
         DwMetaDataFormApi, DwModalButtonStandardConfigs, DwModalConfig, DwModalService, DwModalSize, DwReportingService, 
         DwReportingServiceToken, ensureArray, DwMdFormInitActionHandler, DwMdFormInitActionState, 
         DwMetaDataFormStateService, DwFormContextMode } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { ProjectKickoffMetaDataItemNames, ProjectsKickoffEntity } from '../meta-data/projectkickoff-meta-data.service';
import { map, first } from 'rxjs/operators';
import { Inject, Injectable, OnInit } from '@angular/core';

@DwAction({
    keyName: 'externalKickoffPrint',
    display: 'External Kickoff Print',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: [ ProjectKickoffMetaDataItemNames.ProjectsKickoff ],
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Print External Kickoff',
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-primary',
        iconClass: 'fa fa-file-pdf dw-red',
    },
    defaultSecurityConfig: {
    },
    defaultConfirmConfig: {
        showDialogConfig: true,
        showConfirmDialog: false
    },
    configData: {
        requireValidation: false,
        redirectAfter: false,
        actionMessage: 'Exporting to PDF...',
    }
})
@Injectable()
export class ProjectKickoffExternalPrintActionService implements DwActionHandler, DwMdFormInitActionHandler {
    constructor(
        private dwModalService: DwModalService,
        @Inject(DwReportingServiceToken) protected dwReportingService: DwReportingService,
    ) { }
    formApi : DwMetaDataFormApi;
    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        this.formApi = actionState.formApi;
        return of(this.printHtmlToPdf());
    }

    formInitActionState: DwMdFormInitActionState;
    initAction(formInitActionState: DwMdFormInitActionState) {
        this.formInitActionState = formInitActionState;
    }

    printHtmlToPdf() {
        const args = this.formInitActionState.formApi.getVariableContextValue();
        args.PrintingExternal = true;

        this.formApi.patchVariableContext(args);
        //Used to delay/regenerate html and to save so unsaved changes aren't lost
        this.formApi.saveData(true)
            .pipe(map(saveResult => {
                if (!saveResult.success) {
                    args.PrintingExternal = false;
                    this.formInitActionState.formApi.patchVariableContext(args);
                    return saveResult;
                }
                const html = (this.formApi as any).divForm.nativeElement.outerHTML;
                const finalBodyHtml = '<div class="dw-form-print">' + html + '</div>';
                const kickoff : ProjectsKickoffEntity = this.formApi.getFormData();
            
                const pdf : string = `external-kickoff-${kickoff.KickoffId ?? 0}.pdf`;
                this.dwReportingService.convertHtmlToPdf(finalBodyHtml, 1, pdf, true)
                    .subscribe(result => {
                        const newResult: DwMdPdfResult = {
                            Base64Data: result.Base64Data,
                            FileName: result.FileName,
                            Html: finalBodyHtml
                        }
                        this.dwReportingService.saveExportAsFile(result, pdf);
                        args.PrintingExternal = false;
                        this.formInitActionState.formApi.patchVariableContext(args);
                    });
                const result : DwActionResult = { 
                    success: true
                };
                return result;
            }))
            .subscribe();
        return { success: true };
   }
}